module.exports = __webpack_public_path__ + "img/guide-15.c9781ab5.jpg";